import { render, staticRenderFns } from "./PasskeyIcon.vue?vue&type=template&id=72401ca4"
import script from "./PasskeyIcon.vue?vue&type=script&lang=js"
export * from "./PasskeyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports